export enum TripClosureValidationErrors {
  None = 0,
  ArribedStop = 1,
  WithoutDelivery = 2,
  NotEvidencedStop = 3
}
